import { FunctionalComponent, h } from '@stencil/core';
import {AppRTE} from '.'
import get from 'lodash/get'
import find from 'lodash/find'

interface AppSpecificationsMatrix {
    Specifications: any;
}

export const AppSpecificationsMatrix: FunctionalComponent<AppSpecificationsMatrix> = ({ Specifications }) => {

    let _Specifications: Array<any> = [];

    if (Array.isArray(Specifications)){
        _Specifications = Specifications.map((s) => { s.Product = ''; s.Model = s.Model || ''; return s })
    }
    else{
        Object.keys(Specifications).forEach((k)=>{
            const Product = Specifications[k].Title
            _Specifications = [..._Specifications, ...Specifications[k].Specifications.map((s) => { s.Product = Product; s.Model = s.Model || '';return s})]
        }) 
    }

    // Specifications Matrix
    let products = {}
    _Specifications.reduce(
        (_, { Product, Model }) => { 
            if(!products[Product]) products[Product] = [] 
            if (!products[Product].includes(Model)) products[Product] = [...products[Product], Model]
        },
        products
    )
    
    const features = _Specifications.map(item => item.Type).filter((value, index, self) => self.indexOf(value) === index && value);

    const getRow = (Specifications, feature, products, product) => {
        // IF exists model detail; return nothing
        const match = find(Specifications, { 'Type': feature, 'Product' : product })
        if (!match) return <td colSpan={products[product].length - 1 || 1}>-</td>
        if (get(match, 'Model') != '') return;
        const detail = get(match, 'Detail');
        return <td colSpan={products[product].length - 1 || 1}><AppRTE className='wsio-p-condense' markdown={detail} /></td>
    }

    const getDetail = (Specifications, model, feature) => {
        const match = find(Specifications, { Model: model, Type: feature })
        if (!match) return
        const detail = get(match, 'Detail');
        return <td><AppRTE className='wsio-p-condense' markdown={detail}/></td>;
    }

    return (
        <table class="uk-table uk-table-striped">
            <thead>
                {
                    !Array.isArray(Specifications) && 
                    <tr>
                        <th class="wsio-gold uk-invisible">Specification</th>
                        {Object.keys(products).map((product) => <th colSpan={products[product].length - 1 || 1} class="wsio-gold">{product}</th>)}
                    </tr>
                }
                <tr>
                    <th class="wsio-gold uk-invisible">Specification</th>
                    {Object.keys(products).map(( product ) => {
                        return products[product].filter((model, _, a) => (model != '' || a.length == 1)).map((model) => <th class="wsio-gold">{product == model ? '' : model}</th>)
                    })}
                </tr>
            </thead>
            <tbody>
                {features.map((feature) =>

                    <tr>
                        <td class="wsio-gold">{feature}</td>
                        {
                                Object.keys(products).map((product) => {
                                    return products[product].map((model) => model ? getDetail(_Specifications, model, feature) : getRow(_Specifications, feature, products, product) )
                                })
                        }
                    </tr>

                )}
            </tbody>
        </table>
    )
};